import { MEMBERSHIP_ROLES } from 'src/features/userManagement/types';

export enum NOTIFICATIONS {
    RESERVATION_CANCELLED_BY_CLIENT_NOTIFY_OPERATOR = 'reservation_cancelled_by_client_notify_operator',
    RESERVATION_CREATED_BY_CLIENT_NOTIFY_OPERATOR = 'reservation_created_by_client_notify_operator',
}

export interface Notification {
    id: string;
    notification_type: NOTIFICATIONS;
    is_enabled: boolean;
    recipient_roles: Exclude<MEMBERSHIP_ROLES, MEMBERSHIP_ROLES.CLIENT>[];
}
